import Swiper, { Navigation, Keyboard } from 'swiper'

// # main function
sliders()
function sliders() {
  addClassSwiper()

  if (document.querySelector('.slider-about')) {
    new Swiper('.slider-about', {
      direction: 'horizontal',
      effect: 'slide',
      loop: true,
      loopAdditionalSlides: 2,
      speed: 1000,
      spaceBetween: 0,
      slidesPerView: 1,
      // slidesPerGroupAuto: true,
      watchOverflow: true,

      modules: [Navigation, Keyboard],

      navigation: {
        nextEl: '.slider-about__btn_right',
        prevEl: '.slider-about__btn_left',
      },

      keyboard: {
        enabled: true,
      },

      breakpoints: {
        992.98: {},
        1400.98: {
          direction: 'vertical',
        },
      },
    })
  }
  if (document.querySelector('.slider-welcome')) {
    new Swiper('.slider-welcome', {
      direction: 'horizontal',
      effect: 'slide',
      loop: true,
      loopAdditionalSlides: 2,
      speed: 1000,
      spaceBetween: 0,
      slidesPerView: 1,
      // slidesPerGroupAuto: true,
      watchOverflow: true,

      modules: [Navigation, Keyboard],

      navigation: {
        nextEl: '.slider-welcome__btn_right',
        prevEl: '.slider-welcome__btn_left',
      },

      keyboard: {
        enabled: true,
      },

      breakpoints: {},
    })
  }
  if (document.querySelector('.slider-offering')) {
    new Swiper('.slider-offering', {
      direction: 'horizontal',
      effect: 'slide',
      loop: false,
      speed: 1000,
      spaceBetween: 30,
      slidesPerView: 'auto',
      // slidesPerGroupAuto: true,
      watchOverflow: true,

      modules: [Navigation, Keyboard],

      navigation: {
        nextEl: '.slider-offering__btn_right',
        prevEl: '.slider-offering__btn_left',
      },

      keyboard: {
        enabled: true,
      },

      breakpoints: {
        1400.98: {
          spaceBetween: 60,
        },
      },
    })
  }
  if (document.querySelector('.slider-more')) {
    new Swiper('.slider-more', {
      direction: 'horizontal',
      effect: 'slide',
      loop: false,
      speed: 1000,
      spaceBetween: 0,
      slidesPerView: 'auto',
      // slidesPerGroupAuto: true,
      watchOverflow: true,

      modules: [Navigation, Keyboard],

      navigation: {
        nextEl: '.slider-more__btn_right',
        prevEl: '.slider-more__btn_left',
      },

      keyboard: {
        enabled: true,
      },

      breakpoints: {},
    })
  }
}

//# addClassSwiper
function addClassSwiper() {
  const $sliders = document.querySelectorAll('[class*="__swiper"]')

  $sliders.forEach(slider => {
    slider = slider.parentElement
    const wrapper = slider.children[0]
    const slides = Array.from(wrapper.children)

    slider.classList.add('swiper')
    wrapper.classList.add('swiper-wrapper')
    slides.forEach(addClassSlide)
  })
}

//# addClassSlide
function addClassSlide(slide) {
  slide.classList.add('swiper-slide')
}
